import { NullStateCard } from '@hc/component-lib/hclib/components/molecules/null-state-card';
import { HorizontalSelector } from '@hc/component-lib/hclib/components/molecules/horizontal-selector';
import { HorizontalToggle } from '@hc/component-lib/hclib/components/atoms/horizontal-toggle';
import { Chart, ChartLegendHorizontal } from '@hc/chart-dot-jsx';

import {
  NULL_STATE_WARNINGS,
  NEARBY_CHART_TYPE_TOGGLE_OPTIONS
} from 'legacy/appstore/constants';

import Loading from 'legacy/components/generic/Loading';

import { NearbyPropertiesSection as theme } from 'legacy/css-modules';

const NearbyPropertiesSection = ({
  showBedroomsChart,
  showBathroomsChart,
  showGrossLivingAreaChart,
  showSiteAreaChart,
  showDollarPerGrossLivingAreaChart,
  showDollarPerSiteAreaChart,
  showAgesChart,
  handleClickInfoButton,
  isReportLoaded,
  chartConfig,
  hasChartData,
  chartDataKeySelected,
  chartType,
  toggleOptions,
  onChangeSelectedData,
  onChangeChartType
}) => {
  return (
    <div data-hc-name="nearby-properties-section">
      <div style={{ position: 'relative' }}>
        <div className={theme.ControlRow}>
          {isReportLoaded && (
            <div className={theme.DataSelector}>
              {hasChartData && (
                <HorizontalSelector
                  dataHcName="nearby-properties-charts-options"
                  options={toggleOptions}
                  selected={chartDataKeySelected}
                  onSelect={onChangeSelectedData}
                />
              )}
            </div>
          )}
          <div className={theme.ChartTypeToggle}>
            <HorizontalToggle
              onSelect={onChangeChartType}
              value={chartType}
              options={NEARBY_CHART_TYPE_TOGGLE_OPTIONS}
            />
          </div>
        </div>
        {!isReportLoaded || (isReportLoaded && hasChartData) ? (
          <Loading loading={!isReportLoaded} overlay>
            <div className={theme.chartLegend}>
              <ChartLegendHorizontal
                series={[
                  {
                    legend: {
                      color: 'linear-gradient(0deg, #E8E8E8 0%, #F5F5F5 100%)',
                      label:
                        chartType === 'availableComps'
                          ? 'Comp. Properties'
                          : 'Nearby Properties',
                      stroke: {
                        width: 1,
                        color: '#E5E5E5'
                      }
                    }
                  },
                  {
                    legend: {
                      color:
                        'linear-gradient(180deg, #FFDC49 0%, #FCB715 100%)',
                      label: 'Subject Property',
                      stroke: {
                        width: 0.75,
                        color: '#FDB813'
                      }
                    }
                  }
                ]}
                legendConfig={{}}
              />
            </div>
            <div className={theme.ChartSize}>
              <Chart chartConfig={chartConfig} loading={!isReportLoaded} />
            </div>
          </Loading>
        ) : chartType === 'nearby' ? (
          <NullStateCard
            className={theme.NullStateCard}
            title={NULL_STATE_WARNINGS.nearbyProperties.title}
          >
            {NULL_STATE_WARNINGS.nearbyProperties.message}
          </NullStateCard>
        ) : (
          <NullStateCard
            className={theme.NullStateCard}
            title="Not Enough Comps"
          >
            Change your comp filters to see this chart.
          </NullStateCard>
        )}
      </div>
    </div>
  );
};

export default NearbyPropertiesSection;
